/**
 * /admin/profile route — read-only profile page.
 *
 * Auth gate provided by the _admin layout (beforeLoad token check).
 * No edit modal in this PR (Decision D7 — T-PROFILE-EDIT backlog).
 */
import { createFileRoute } from '@tanstack/react-router';
import { AccountInfo } from '../../components/profile/AccountInfo';
import { ActivityList } from '../../components/profile/ActivityList';
import { PermissionsList } from '../../components/profile/PermissionsList';
import { ProfileHero } from '../../components/profile/ProfileHero';
import { StatsStrip } from '../../components/profile/StatsStrip';
import { getCachedUser } from '../../lib/auth';
import { useMe } from '../../queries/auth';

export const Route = createFileRoute('/_admin/profile')({
  component: ProfilePage,
});

function ProfilePage() {
  const { data: freshUser, isLoading } = useMe();
  const cachedUser = getCachedUser();

  // Prefer fresh API data; fall back to cached for instant render
  const user = freshUser ?? cachedUser;

  return (
    <main className="flex-1 overflow-auto">
      <div className="max-w-[880px] mx-auto px-14 py-8 space-y-8">
        {/* Hero: avatar + name + role + pills */}
        <ProfileHero user={user} isLoading={isLoading && !user} />

        {/* Stats strip: 4-col hairline-joined grid */}
        {user && <StatsStrip user={user} />}

        {/* 2-col body */}
        {user && (
          <div className="grid grid-cols-2 gap-6">
            <AccountInfo user={user} />
            <PermissionsList grants={user.grants} />
          </div>
        )}

        {/* Full-width activity */}
        <ActivityList />
      </div>
    </main>
  );
}
